/* eslint-disable prettier/prettier */
/**
 * OIDC Configuration for Keycloak Authentication
 *
 * This configuration is used by @axa-fr/react-oidc to handle
 * authentication with the Keycloak identity provider.
 */

export const oidcConfiguration = {
  // Keycloak client ID (use flipbit-frontend for both dev and prod now)
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "flipbit-frontend",

  // Redirect URIs for OAuth2 flow
  redirect_uri: window.location.origin + "/authentication/callback",
  silent_redirect_uri:
    window.location.origin + "/authentication/silent-callback",

  // OAuth2/OIDC scopes
  scope: "openid profile email",

  // Keycloak authority (realm URL)
  authority:
    process.env.REACT_APP_KEYCLOAK_AUTHORITY ||
    "https://idp.gps-mapping.com/realms/dmg-sso",

  // Service worker mode (set to false for development)
  service_worker_only: false,

  // Automatically refresh tokens before expiration
  automaticSilentRenew: true,

  // Load user info from Keycloak userinfo endpoint
  loadUserInfo: true,

  // Monitor session state
  monitor_session: true,

  // Refresh time before expiration (in seconds)
  refresh_time_before_tokens_expiration_in_second: 70,

  // Token renewal mode
  token_renew_mode: "access_token_invalid",
};
